import localeText from "../../../../locale";

import { useEffect, useRef, useState } from "react";
import BrandsService from "../../../../service/BrandsService";
import { Toast } from "primereact/toast";
import "./NewBrands.css";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { locale } from "../../../../utilities/locale/locale";
import SubcategoriesService from "../../../../service/SubcategoriesService";
import { useToastContext } from "../../../../contexts/ToastContext/ToastContext";

const NewBrands = (props) => {
  const brandService = new BrandsService();
  const subcategoriesService = new SubcategoriesService();

  const toast = useRef(null);

  const [descriptionBrands, setDescriptionBrands] = useState("");
  const [loadingRegister, setLoadingRegister] = useState(false);
  const [selectedSubCategories, setSelectedSubCategories] = useState([]);
  const [alreadySelectedSubCategories, setAlreadySelectedSubCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [isLoadingSubCategories, setIsLoadingSubCategories] = useState(false);

  const { showErrorToast } = useToastContext();

  //  Get all brands and return the id of an specific brand
  const getBrandById = async (selectedBrand) => {
    const { result } = await brandService.getBrands(localStorage.getItem("__extraconomy_token"));

    const brand = result.filter((brand) => brand.description === selectedBrand);

    const { id } = brand[0];

    return id;
  };

  const asyncLinkSubCategories = async (idbrand) => {
    const promises = selectedSubCategories.map(
      async (selectedSubCategory) => await linkBrandSubcategory(idbrand, selectedSubCategory.id)
    );

    await Promise.all(promises);
  };

  async function linkBrandSubcategory(idbrand, idsubcategory) {
    try {
      setLoadingRegister(true);

      const res = await subcategoriesService.postLinkBrandSubcategory(
        localStorage.getItem("__extraconomy_token"),
        idbrand,
        idsubcategory
      );

      if (res.messageCode !== 200000) {
        showErrorToast({ code: res.messageCode });
        setLoadingRegister(false);
        if (res.messageCode === 500000) console.log(res);
        return;
      }
      if (res.messageCode === 200000) {
        if (res.messageCode !== 200000) {
          showErrorToast({ code: res.messageCode });
          if (res.messageCode === 500000) console.log(res);
          setLoadingRegister(false);
          return;
        }
      } else {
        showErrorToast({ code: res.messageCode });
        setLoadingRegister(false);
        return;
      }
    } catch (e) {
      showErrorToast({ detail: "unexpectedErrorRegisterProduct" });
      setLoadingRegister(false);
      console.log(e);
    }
  }

  async function registerBrands() {
    if (selectedSubCategories.length === 0 && !props.isEdit) {
      toast.current.show({
        severity: "error",
        summary: localeText("chooseSubcategory"),
      });

      return;
    }

    try {
      setLoadingRegister(true);

      let res;

      if (!props?.isEdit)
        res = await brandService.postRegisterBrands(
          localStorage.getItem("__extraconomy_token"),
          descriptionBrands
        );
      else
        res = await brandService.postEditBrands(
          localStorage.getItem("__extraconomy_token"),
          descriptionBrands,
          props.id
        );

      if (res.messageCode !== 200000) {
        showErrorToast({ code: res.messageCode });
        setLoadingRegister(false);
        if (res.messageCode === 500000) console.log(res);
        return;
      }
      if (res.messageCode === 200000) {
        const idbrand = await getBrandById(descriptionBrands);

        await asyncLinkSubCategories(idbrand);

        window.location.href = "/listbrands";
        if (res.messageCode !== 200000) {
          showErrorToast({ code: res.messageCode });
          if (res.messageCode === 500000) console.log(res);
          setLoadingRegister(false);
          return;
        }
      } else {
        showErrorToast({ code: res.messageCode });
        setLoadingRegister(false);
        return;
      }
    } catch (e) {
      toast.current.show({
        severity: "error",
        summary: localeText("error"),
        detail: localeText("unexpectedErrorRegisterProduct"),
        life: 6000,
      });
      setLoadingRegister(false);
      console.log(e);
    }
  }

  const createSubCategoryList = async () => {
    setIsLoadingSubCategories(true);
    const { result } = await subcategoriesService.getSubcategories(
      localStorage.getItem("__extraconomy_token")
    );

    const editedCategories = result.map((oldFormatCategory) => {
      const {
        id,
        descriptionEnglish,
        descriptionSpanish,
        descriptionItalian,
        descriptionPortuguese,
      } = oldFormatCategory;

      let description = "";

      switch (locale) {
        case "pt":
          description = descriptionPortuguese;
          break;
        case "it":
          description = descriptionItalian;
          break;
        case "es":
          description = descriptionSpanish;
          break;
        default:
          description = descriptionEnglish;
          break;
      }

      return { label: description, id, brands: oldFormatCategory.brands };
    });

    const listedCategories = [...editedCategories];

    if (props?.isEdit) {
      const selectedSubCategoriesFiltered = listedCategories?.reduce((acc, subCategory) => {
        const brand = subCategory?.brands?.find((brand) => brand.id === props?.id);
        if (brand) {
          acc.push(subCategory);
        }
        return acc;
      }, []);

      const filteredCategories = listedCategories.filter(
        (category) => !selectedSubCategoriesFiltered.includes(category)
      );

      setAlreadySelectedSubCategories(selectedSubCategoriesFiltered);
      setSubCategories(filteredCategories);
    } else {
      setSubCategories(listedCategories);
    }
    setIsLoadingSubCategories(false);
  };

  useEffect(() => {
    createSubCategoryList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.id]);

  useEffect(() => {
    if (props?.isEdit) setDescriptionBrands(props?.descriptionBrand);
  }, [props?.id, props?.descriptionBrand, props?.isEdit]);

  return (
    <>
      <Toast ref={toast} />
      <div className="border-round" style={{ backgroundColor: "#46a748" }}>
        <h1 className="py-6 text-center text-0 lg:text-6xl md:text-6xl text-4xl">
          {props.isEdit ? localeText("edit") : localeText("addNewBrand")}
        </h1>
      </div>
      <div className="card border-1 border-300">
        <div className="mb-4">
          <h3 className="my-4">{localeText("brandInfo")}</h3>
          <p className="text-600">{localeText("brandFields")}</p>
          <div className="grid mt-6">
            <div className="col-12">
              {isLoadingSubCategories ? (
                <div className="text-center">
                  <i className="pi pi-spin pi-spinner" style={{ fontSize: "2em" }}></i>
                </div>
              ) : (
                <>
                  <label htmlFor="descriptionBrand">{localeText("descriptionBrand")}</label>
                  <InputText
                    className="w-full my-2"
                    name="descriptionBrand"
                    value={descriptionBrands}
                    onChange={(e) => setDescriptionBrands(e.target.value)}
                  />

                  <label>{localeText("subcategory")}</label>
                  <Dropdown
                    className="text-center w-full my-2"
                    value={selectedSubCategories[selectedSubCategories.length - 1]}
                    options={subCategories}
                    editable={false}
                    onChange={(e) => {
                      setSelectedSubCategories((oldState) => {
                        if (!oldState.includes(e.value)) return [...oldState.push(e.value)];

                        return [...oldState];
                      });
                    }}
                    style={{ minWidth: "108px" }}
                  />

                  <ul
                    className="list-none my-4 p-0"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      flexWrap: "wrap",
                    }}
                  >
                    {props?.isEdit &&
                      alreadySelectedSubCategories.map((listedCategory) => (
                        <li
                          className="border-2 border-400 mt-4 mx-2 p-2"
                          style={{ borderRadius: "4em" }}
                          key={listedCategory.id}
                        >
                          {listedCategory.label}
                        </li>
                      ))}

                    {selectedSubCategories.map((listedCategory) => (
                      <li
                        className="border-2 border-400 mt-4 mx-2 p-2"
                        style={{ borderRadius: "4em" }}
                        key={listedCategory.id}
                      >
                        {listedCategory.label}{" "}
                        <span
                          className="mx-2 cursor-pointer"
                          style={{ fontWeight: "bold" }}
                          onClick={() =>
                            setSelectedSubCategories((oldState) => {
                              return oldState.filter((element) => element !== listedCategory);
                            })
                          }
                        >
                          X
                        </span>
                      </li>
                    ))}
                  </ul>
                </>
              )}
            </div>
            <div className="d-flex align-items-end flex-column">
              <Button
                label={localeText("registerBrand")}
                loading={loadingRegister}
                className="mr-2 w-full lg:w-auto md:w-auto m-1"
                onClick={() => registerBrands(true)}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewBrands;
